import type { ShellContribution } from '@web-app/components/Shell/shell-contribution';
import { useSupportShellContribution } from '@web-app/hooks/support-concierge/useSupportShellContribution';
import { createContext, type ReactNode, useContext } from 'react';

const ShellContributionsContext = createContext<ShellContribution[]>([]);

/** The one place features join the shell: add the feature's hook here. */
function useRegisteredContributions(): ShellContribution[] {
  return [useSupportShellContribution()];
}

export function ShellContributionsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const contributions = useRegisteredContributions();
  return (
    <ShellContributionsContext.Provider value={contributions}>
      {children}
    </ShellContributionsContext.Provider>
  );
}

export function useShellContributions(): ShellContribution[] {
  return useContext(ShellContributionsContext);
}
